export const TEST_ORIENTATION_MINIMAL_SCORE = 60;
export const PARCOURS_FORMATION_MINIMAL_SCORE = 70;
export const PARCOURS_FORMATION_TEST_DURATION = 5; // In minutes
